import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { usePostHog } from 'posthog-js/react';

import { ENROLL_PATIENT_PLATGEN } from '@/apollo/mutations';
import { getPdtUid, Product } from '@/utils/productHelpers';

type EnrollArgs = {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  phone?: string;
  product: Product;
  springId: string;
};

export const useEnrollPatientPlatgen = () => {
  const posthog = usePostHog();
  const [enrollPatientPlatgen, { loading }] = useMutation(ENROLL_PATIENT_PLATGEN);

  const enroll = useCallback(async (args: EnrollArgs) => {
    const response = await enrollPatientPlatgen({
      variables: {
        email: args.email.trim(),
        firstName: args.firstName,
        lastName: args.lastName,
        password: args.password,
        pdtUid: getPdtUid(args.product),
        externalId: args.springId,
        organizationSlug: 'spring-health',
        termsAndPrivacyAcknowledgedAt: new Date().toISOString(),
        phone: args.phone || null,
        posthogDistinctId: posthog?.get_distinct_id() || null,
      },
    });

    return response;
  }, [enrollPatientPlatgen, posthog]);

  return { enroll, loading };
};
